import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { performanceMonitor } from './utils/performanceMonitor';
import { initializeAnalyticsService } from './services/analyticsService';
import { MockDataProvider } from './services/mockDataProvider';

// Initialize performance monitoring
performanceMonitor.initialize();

// Initialize analytics service with mock data provider (Phase 1)
const mockDataProvider = new MockDataProvider();
initializeAnalyticsService(mockDataProvider);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Log performance report after app loads (in development)
if (import.meta.env.MODE === 'development') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      performanceMonitor.logReport();
    }, 1000);
  });
}
